const data = {
    customerId: window.customer.id,
    customerEmail: window.customer.email,
    products: [],
    itemCount: 0
};
export default data;
